import api from './api'
const install = Vue => {
  if (install.installled) 
    return ;
  install.installled = true; 
  Object.defineProperties(Vue.prototype,{
    //此处挂载在Vue原型到$api对象上
    $api: {
      get(){
        return api
      }
    }
  })
}
export default install


// WEBPACK FOOTER //
// ./src/http/index.js